export const EDUCATION_OPTIONS = {
  HIGHER: 'Higher Education',
  SECONDARY_SPECIAL: 'Secondary Special Education',
  COURSE: 'Course',
  TRAINING: 'Training',
};

export const DOCUMENT_TYPES = {
  DIPLOMA: 'Diploma',
  CERTIFICATE: 'Certificate',
};
